// src/pages/not-found/NotFound.js

import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from 'antd';
import { ExclamationCircleTwoTone } from '@ant-design/icons';
import logo from '../../assets/images/bg/logo.svg';
import './NotFound.css';

const NotFound = () => {
  return (
    <div
      className="auth-container"
      style={{
        minHeight: '100vh',
        height: 'auto',
        display: 'flex',
        overflowY: 'scroll',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 24,
        background:
          'radial-gradient(900px 500px at 0% 0%, rgba(0,77,84,0.08) 0%, rgba(0,77,84,0) 60%), radial-gradient(800px 420px at 100% 0%, rgba(0,77,84,0.06) 0%, rgba(0,77,84,0) 60%), linear-gradient(135deg, #f5fbfb 0%, #eef8f8 100%)',
      }}
    >
      <div style={{ width: '100%', maxWidth: 520 }}>
        <div
          style={{
            marginBottom: 16,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 12,
          }}
        >
          <img src={logo} alt="VitalStaf" style={{ height: 48 }} />
        </div>

        <div
          className="auth-form-wrapper"
          style={{
            background: 'rgba(255,255,255,0.94)',
            borderRadius: 20,
            boxShadow: '0 12px 30px rgba(0,77,84,0.16), 0 6px 14px rgba(0,77,84,0.12)',
            padding: 24,
            textAlign: 'center',
          }}
        >
          <div style={{ marginBottom: 8 }}>
            <div
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: 8,
                padding: '6px 12px',
                borderRadius: 999,
                background: 'linear-gradient(135deg, rgba(0,77,84,0.08), rgba(0,77,84,0.06))',
                color: '#004d54',
                fontWeight: 600,
                fontSize: 12,
              }}
            >
              <ExclamationCircleTwoTone twoToneColor="#004d54" />
              Oops — page not found
            </div>
            <h2 style={{ margin: '12px 0 6px', fontWeight: 700, color: '#0f172a' }}>Page not found</h2>
            <p style={{ margin: 0, color: '#334155' }}>
              The page you are looking for doesn’t exist or may have been moved.
            </p>
          </div>

          <div style={{ marginTop: 12 }}>
            <Link to="/">
              <Button
                type="primary"
                size="large"
                block
                style={{ backgroundColor: '#004d54', borderColor: '#004d54', boxShadow: '0 6px 16px rgba(0,77,84,0.24)' }}
              >
                Go back to Home
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
